import './_product-card-swatches.scss';

export default () => {};
